@import '../../../../constants/spacing.module.less';

.tab-list-container {
  display: flex;
  flex-flow: row nowrap;
  gap: @space-16;
}
